import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-money-01',
  standalone: true,
  templateUrl: '../../assets/money-01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMoney01Icon {}
